document.addEventListener('DOMContentLoaded', () => {
  const isMobile = () => window.innerWidth < 750;

  const updateAccordionState = () => {
    document.querySelectorAll('.footer-block__details').forEach((details, index) => {
      const content = details.querySelector('.footer-block__details-content');
      if (!isMobile()) {
        details.setAttribute('open', '');
        if (content) {
          content.style.gridTemplateRows = '1fr';
          content.style.opacity = '1';
        }
      } else {
        if (index === 0) {
          details.setAttribute('open', '');
          if (content) {
            content.style.gridTemplateRows = '1fr';
            content.style.opacity = '1';
          }
        } else {
          details.removeAttribute('open');
          if (content) {
            content.style.gridTemplateRows = '0fr';
            content.style.opacity = '0';
          }
        }
      }
    });
  };

  updateAccordionState();

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateAccordionState, 150);
  });

  document.querySelectorAll('.footer-block__details').forEach((details) => {
    const summary = details.querySelector('summary');
    if (!summary) return;

    summary.addEventListener('click', (e) => {
      if (!isMobile()) {
        e.preventDefault();
        return;
      }

      e.preventDefault();

      const isOpen = details.hasAttribute('open');

      // Close other open accordions smoothly
      document.querySelectorAll('.footer-block__details').forEach((other) => {
        if (other !== details && other.hasAttribute('open')) {
          closeAccordion(other);
        }
      });

      if (isOpen) {
        closeAccordion(details);
      } else {
        openAccordion(details);
      }
    });
  });

  function openAccordion(details) {
    const content = details.querySelector('.footer-block__details-content');
    details.setAttribute('open', '');
    if (content) {
      void content.offsetHeight; // Force reflow
      content.style.gridTemplateRows = '1fr';
      content.style.opacity = '1';
    }
  }

  function closeAccordion(details) {
    const content = details.querySelector('.footer-block__details-content');
    if (content) {
      content.style.gridTemplateRows = '0fr';
      content.style.opacity = '0';
    }
    setTimeout(() => {
      details.removeAttribute('open');
    }, 350);
  }
});